import { propOr } from 'ramda';
import { useI18n } from '@namespace/i18n';
import { normalizeRiskFreeBonusDetails } from '../../normalizers';
import { useBonusesStore } from '../../store';
import { useAllTypesBonuses } from '../allTypesBonuses';

const selectRiskFreeBonuses = () => propOr({}, 'riskFreeBonuses');
const selectRiskFreeBonusesHistory = () => propOr({}, 'riskFreeBonusesHistory');
const selectBonusDetails = () => propOr({}, 'bonusDetails');

export const useRiskFreeBonus = (bonusId) => {
  const riskFreeBonuses = useBonusesStore(selectRiskFreeBonuses());
  const riskFreeBonusesHistory = useBonusesStore(
    selectRiskFreeBonusesHistory()
  );
  const bonusDetails = useBonusesStore(selectBonusDetails());
  const allTypesBonusesData = useAllTypesBonuses();
  const { data: bonusesData } = riskFreeBonuses;
  const { data: bonusesHistoryData } = riskFreeBonusesHistory;
  const { t, f } = useI18n();

  const bonusData = bonusId
    ? {
        ...bonusesData,
        ...bonusesHistoryData,
        ...allTypesBonusesData // should be here for finding riskfree bonus when all bonuses in single list
      }[bonusId]
    : bonusDetails;

  return normalizeRiskFreeBonusDetails({ bonusData, f, t });
};
